// Stub for user assets (not used in parents)
export const IconViewed = (_props?: { className?: string }) => null;
export const CheckMark = (_props?: { className?: string }) => null;
